import { Component, inject, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ContentType } from '../../pages/content-creation/content-creation';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { ColorService } from '../../services/color.service';
import { InputRadioElementItem } from '../../types/input-radio-element-item.type';
import { InputRadioElement } from '../input-radio-element/input-radio-element';

const contentItemList: InputRadioElementItem<ContentType>[] = [
  {
    value: 'scenic',
    title: 'content_type.scenic',
    icon: 'video',
    // default: true,
  },
  {
    value: 'gps-only',
    title: 'content_type.gps-only',
    icon: 'gps_stroke',
  },
  {
    value: 'coaching',
    title: 'content_type.coaching',
    icon: 'coaching_stroke',
  },
  {
    value: 'workout',
    title: 'content_type.workout',
    icon: 'workout_stroke',
  },
];

@Component({
  selector: 'app-content-type-block',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    UpperFirstLetterPipe,
    InputRadioElement,
  ],
  templateUrl: './content-type-block.html',
  styleUrl: './content-type-block.scss',
})
export class ContentTypeBlock {
  colorService: ColorService = inject(ColorService);
  readonly selectedContentType: InputSignal<ContentType | undefined> = input<
    ContentType | undefined
  >();
  readonly disabled: InputSignal<boolean> = input<boolean>(false);
  contentTypeSelected: OutputEmitterRef<ContentType> = output<ContentType>();
  contentItemList: InputRadioElementItem<ContentType>[] = contentItemList;
  textColor: string = this.colorService.getCssVariable('--text-color');
  textColor500: string = this.colorService.getCssVariable('--neutral-500');

  onContentTypeChange(value: ContentType): void {
    this.contentTypeSelected.emit(value);
  }
}
